import React from 'react';

export type CardSuit = 'spades' | 'hearts' | 'diamonds' | 'clubs' | 'joker';

interface CardDisplayProps {
  suit: CardSuit;
  rank: string;
  isTrump?: boolean;
  isColoredJoker?: boolean;
}

export function CardDisplay({
  suit,
  rank,
  isTrump = false,
  isColoredJoker = false,
}: CardDisplayProps) {
  const suitSymbol: Record<CardSuit, string> = {
    spades: '♠',
    hearts: '♥',
    diamonds: '♦',
    clubs: '♣',
    joker: '🃏',
  };

  const suitColor =
    suit === 'hearts' || suit === 'diamonds' || isColoredJoker
      ? 'text-red-600'
      : 'text-gray-900';

  return (
    <div
      className={`
        inline-flex items-center justify-center
        w-12 h-16 rounded-lg border-2
        ${isTrump ? 'border-yellow-500 bg-yellow-50' : 'border-gray-300 bg-white'}
        ${suitColor}
        font-bold text-sm shadow-sm
      `}
    >
      <div className="text-center">
        <div className="text-xs">{rank}</div>
        <div className="text-lg">{suitSymbol[suit]}</div>
      </div>
    </div>
  );
}
